import { API_BASE_URL } from './index';
import { callApi } from 'utils/callApi';

// eslint-disable-next-line import/prefer-default-export

export const addRequestTestimonialRequest = ({ studentReqTo, notes }) =>
    callApi({
        requestFunction: (axios) =>
            axios.post(`${API_BASE_URL}/web/users/request-testimonial/add`, {
                studentReqTo,
                notes
            }),
        successCode: 200
    });

export const getStudentRequest = () =>
    callApi({
        requestFunction: (axios) => axios.get(`${API_BASE_URL}/web/users/list`),
        successCode: 200,
        showToastOnSuccess: false,
        showToastOnError: false
    });

export const getTestimonialSentRequest = () =>
    callApi({
        requestFunction: (axios) => axios.get(`${API_BASE_URL}/web/users/request-testimonial/sent`),
        successCode: 200,
        showToastOnSuccess: false,
        showToastOnError: false
    });

export const getTestimonialReceivedRequest = () =>
    callApi({
        requestFunction: (axios) => axios.get(`${API_BASE_URL}/web/users/request-testimonial/receive`),
        successCode: 200,
        showToastOnSuccess: false,
        showToastOnError: false
    });
